// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__3SxJq","disabled":"FileBtn_disabled__3baQT","warn":"FileBtn_warn__375Gn","fade":"FileBtn_fade__3aSi6"};